module.exports = __webpack_public_path__ + "static/media/chokha2.5fbf4836.webp";